import JpegCameraHtml5 from '@/assets/js/jpeg_camera_no_flash'

const JpegCameraPlugin = {
  install (Vue, options) {
    Vue.prototype.$jpegCamera = JpegCameraHtml5
    Vue.jpegCamera = JpegCameraHtml5
  }
}

export default JpegCameraPlugin



// WEBPACK FOOTER //
// ./src/plugins/jpegCamera.js